import { LISTAR_CATPERIODICIDAD } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case LISTAR_CATPERIODICIDAD:
      return {
        ...state,
        catPeriodicidad: action.payload,
      };
    default:
      return state;
  }
};
